const DEFAULT_BRANDING = {
    // appName: {
    //     en: "Al-Mohandes Furniture",
    //     ar: "المهندس فيرنتشر"
    // },
    appName: {
        en: "",
        ar: ""
    },
    // contact: {
    //     phone1: "+249 124 875 525",
    //     phone2: "+249 966 966 670",
    //     email: "almohandes.furniture.app@gmail.com"
    // },
    contact: {
        phone1: "",
        phone2: "",
        email: ""
    },
    colors: {
        primary: "#D4AF37", // Rich wood brown
        primaryHover: "#FFFFFF", // Darker brown
        secondary: "#FFFFFF", // Lighter wood tone
        accent: "#FFFFFF", // Soft accent
        bgBody: "#FFFFFF", // Warm cream background
        bgHeader: "#FFFFFF", // Header background
        textHeader: "#FFFFFF", // Header text color
        textMain: "#FFFFFF", // Main body text
        textMuted: "#FFFFFF", // Muted/secondary text
        border: "#FFFFFF", // Default border color

        // Premium Glassmorphism Tokens
        glassBg: "rgba(255, 255, 255, 0.03)",
        glassBorder: "rgba(255, 255, 255, 0.05)",
        glassShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
        cardGlassBg: "rgba(255, 255, 255, 0.05)",
        cardGlassBorder: "rgba(255, 255, 255, 0.1)",
    },
    // colors: {
    //     primary: "#5D2E17", // Rich wood brown
    //     primaryHover: "#4A2512", // Darker brown
    //     secondary: "#A67B5B", // Lighter wood tone
    //     accent: "#C69774", // Soft accent
    //     bgBody: "#FDF7F0", // Warm cream background
    //     bgHeader: "#FFFFFF", // Header background
    //     textHeader: "#111827", // Header text color
    //     textMain: "#1F2937", // Main body text
    //     textMuted: "#6B7280", // Muted/secondary text
    //     border: "#E5E7EB", // Default border color
    // },
    //     colors: {
    //     primary: "#D4AF37",       // Logo Gold
    //     primaryHover: "#B5952F",  // Slightly darker Gold
    //     secondary: "#E6C65C",     // Soft lighter gold
    //     accent: "#F1D77A",        // Elegant highlight gold

    //     bgBody: "#FAFAFA",        // Very light grey/white
    //     bgHeader: "#FFFFFF",      // Header background

    //     textHeader: "#333333",    // Logo Dark Grey
    //     textMain: "#1F2937",      // Main body text (dark slate)
    //     textMuted: "#6B7280",     // Muted text

    //     border: "#E5E7EB",        // Subtle borders

    //     footerBg: "#1A1A1A",      // Deep luxury dark
    //     footerText: "#F9FAFB"     // Soft white
    // },

    // Premium Glassmorphism Tokens
    glassBg: "rgba(255, 255, 255, 0.03)",
    glassBorder: "rgba(255, 255, 255, 0.05)",
    glassShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
    cardGlassBg: "rgba(255, 255, 255, 0.05)",
    cardGlassBorder: "rgba(255, 255, 255, 0.1)",

    ui: {
        buttonRadius: "0rem", // '0' for square, '9999px' for pill
        cardRadius: "1rem", // Default card rounding
        inputRadius: "0.5rem", // Default input rounding
        cardShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
        cardPadding: "1.5rem",
        navbarHeight: "80px",
        footerBg: "#FFFFFF",
        footerText: "#FFFFFF",
        // footerBg: "#111827",
        // footerText: "#FFFFFF",
        transitionSpeed: "0.3s", // Default animation speed
    },
    fonts: {
        bodyEn: "'Roboto', sans-serif",
        bodyAr: "'Cairo', 'Tajawal', sans-serif",
        headingEn: "'Roboto', sans-serif",
        headingAr: "'Cairo', 'Tajawal', sans-serif",
    },
    logo: {
        path: (process.env.PUBLIC_URL || '') + "/logo.png",
        // alt: "LuxeHome",
        alt: "",
        showText: false
    },
    // socialLinks: {
    //     facebook: "https://facebook.com/almohandes",
    //     whatsapp: "+201125581782",
    //     instagram: "https://instagram.com/almohandes",
    //     tiktok: "https://tiktok.com/@almohandes"
    // }
    socialLinks: {
        facebook: "https://facebook.com/almohandes",
        whatsapp: "+11111111111",
        instagram: "https://instagram.com/almohandes",
        tiktok: "https://tiktok.com/@almohandes"
    },
    // seo: {
    //     defaultTitle: {
    //         en: "Al-Mohandes Furniture | Luxury Modern Decor",
    //         ar: "المهندس فيرنتشر | أرقى الأثاث المودرن"
    //     },
    //     defaultDescription: {
    //         en: "Discover the finest luxury furniture and home decor. Custom-made bedrooms, living rooms, and office furniture with premium quality.",
    //         ar: "اكتشف أرقى الأثاث المودرن والديكورات المنزلية. غرف نوم، غرف معيشة، وأثاث مكتبي بأعلى معايير الجودة."
    //     },
    //     sellingPoints: {
    //         en: ["Best Seller", "Premium Quality", "Luxury Designs", "Fast Delivery", "Verified Guarantee"],
    //         ar: ["الأكثر مبيعاً", "جودة فاخرة", "تصاميم حصرية", "ضمان معتمد", "توصيل آمن"]
    //     }
    // },
    seo: {
        defaultTitle: {
            en: "",
            ar: ""
        },
        defaultDescription: {
            en: "",
            ar: ""
        },
        sellingPoints: {
            en: ["", "", "", "", ""],
            ar: ["", "", "", "", ""]
        }
    },
    // favicon: {
    //     path: "/favicon.ico"
    // },
    // appleTouchIcon: {
    //     path: "/apple-touch-icon.png"
    // },
    // footerDescription: {
    //     en: "Premium furniture crafted for comfort, durability, and timeless style.",
    //     ar: "أثاث فاخر صُمم للراحة، المتانة، والأناقة الخالدة."
    // }
    favicon: {
        path: "/favicon.ico"
    },
    appleTouchIcon: {
        path: "/apple-touch-icon.png"
    },
    footerDescription: {
        en: "",
        ar: ""
    },
    defaultLanguage: 'en', // 'en' or 'ar'
    features: {
        cart: true,
        wishlist: true,
        comparison: true,
        userPortal: true,
        payments: true
    },
    compliance: {
        enableGlobalConsentBanner: true,
        enableEgyptMarketingConsent: true,
        enableExplicitDataProcessing: true,
        enableDataSubjectRights: true
    }
};

function isObject(v) {
    return v && typeof v === 'object' && !Array.isArray(v);
}

function mergeDeep(target, source) {
    if (!isObject(target) || !isObject(source)) return source;
    const out = { ...target };
    Object.keys(source).forEach(key => {
        if (isObject(source[key])) {
            out[key] = mergeDeep(target[key] || {}, source[key]);
        } else {
            out[key] = source[key];
        }
    });
    return out;
}

const handler = {
    get(_, prop) {
        const overrides = window.__BRANDING__ || {};
        if (prop === '__raw') return overrides;
        const base = DEFAULT_BRANDING[prop];
        if (base === undefined) return undefined;
        if (isObject(base)) {
            return mergeDeep(base, overrides[prop] || {});
        }
        return overrides[prop] !== undefined ? overrides[prop] : base;
    }
};

const BRANDING = new Proxy(DEFAULT_BRANDING, handler);

export default BRANDING;
